var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 2.83594V6.87644H14.03V14.0359H12.98V6.87644H11.51V2.83594H15.5ZM9.025 2.83594V6.41568H10.495V10.4562H9.025V14.0359H7.975V10.4562H6.505V6.41568H7.975V2.83594H9.025ZM4.02 2.83594V9.95999H5.49V14.0005H1.5V9.95999H2.97V2.83594H4.02Z",
    fill: "#303C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.37157c23e46b8d8c1e7d75ad2d1842bb.svg";
export { ForwardRef as ReactComponent };